// pages/FormViewerPage/sections/CouponCodeInput.tsx — Input kode kupon (collapsible).
// Validasi lewat RPC validate_form_voucher_code; diskon final dihitung ulang di server.
import React, { useState } from 'react';
import { ms } from '../../../locales/ms';

export const CouponCodeInput: React.FC<{ hook: any }> = ({ hook }) => {
    const { form, couponCode, setCouponCode, couponApplied, couponError, couponApplying, applyCoupon, clearCoupon } = hook;
    const [open, setOpen] = useState(false);
    const T = {
        applied: (c: string) => ms(form, () => `🎟️ Kupon ${c} digunakan`, `🎟️ Kupon ${c} diterapkan`),
        hasCoupon: ms(form, () => '🎟️ Ada kod kupon?', '🎟️ Punya kode kupon?'),
        appliedTitle: (c: string) => ms(form, () => `Kupon ${c} digunakan`, `Kupon ${c} diterapkan`),
        appliedSub: ms(form, () => 'Potongan akan dikira dalam jumlah pesanan.', 'Potongan akan dihitung di total pesanan.'),
        remove: ms(form, () => 'Padam', 'Hapus'),
        placeholder: ms(form, () => 'Masukkan kod', 'Masukkan kode'),
        checking: ms(form, () => 'Menyemak...', 'Memeriksa...'),
        apply: ms(form, () => 'Guna', 'Terapkan'),
        hint: ms(form, () => 'Tekan Guna untuk semak kod & lihat potongannya.', 'Tekan Terapkan untuk cek kode & lihat potongannya.'),
    };

    return (
        <div>
            <button type="button" onClick={() => setOpen(o => !o)} className="w-full flex items-center justify-between text-xs font-semibold text-slate-500 dark:text-slate-400">
                <span>{couponApplied ? T.applied(couponApplied.code) : T.hasCoupon}</span>
                <svg className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {open && (
                <div className="mt-2">
                    {couponApplied ? (
                        <div className="flex items-center justify-between gap-2 py-2">
                            <div className="min-w-0">
                                <p className="text-xs font-semibold text-emerald-700 dark:text-emerald-300">{T.appliedTitle(couponApplied.code)}</p>
                                <p className="text-[11px] text-emerald-600 dark:text-emerald-400">{T.appliedSub}</p>
                            </div>
                            <button type="button" onClick={clearCoupon} className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 hover:text-red-500 shrink-0">{T.remove}</button>
                        </div>
                    ) : (
                        <div className="flex gap-2">
                            <input type="text" value={couponCode} onChange={e => setCouponCode(e.target.value.toUpperCase())} placeholder={T.placeholder}
                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); applyCoupon(); } }}
                                className="flex-1 min-w-0 p-2 rounded-lg text-sm font-mono uppercase focus:ring-2 focus:ring-orange-500/20 outline-none bg-slate-100 dark:bg-slate-700 border-0" />
                            <button type="button" onClick={applyCoupon} disabled={couponApplying || !couponCode.trim()}
                                className="px-3 py-2 rounded-lg bg-orange-600 hover:bg-orange-700 text-white text-xs font-bold disabled:opacity-50 disabled:cursor-not-allowed shrink-0">
                                {couponApplying ? T.checking : T.apply}
                            </button>
                        </div>
                    )}
                    {!couponApplied && <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-1">{T.hint}</p>}
                    {couponError && !couponApplied && <p className="text-xs text-red-500 mt-1.5">{couponError}</p>}
                </div>
            )}
        </div>
    );
};
